import { useEffect, useState } from "react";
import styled from "styled-components";
import { europeCountries, majorAllyCountries, boycottCountries } from "../model/alternativeTypes";
import { displayStringFromCountry } from "../locales/locales";
import { LazySelectWrapper } from "./LazyLoadSelect";

export enum CountryType {
  EuropeAllyOrUs,
  RussiaFriendly
}

interface CountryDropdownProps {
  countryTypes: CountryType;
  country: string;
  onChange: (country: string) => void;
}

interface Option {
  value: string;
  label: string;
}

export default function CountryDropdown(props: CountryDropdownProps) {
  const [countries, setCountries] = useState<Option[]>([]);
  const [selected, setSelected] = useState<Option[]>([]);

  useEffect(() => {
    const countries: Option[] = []
    switch (props.countryTypes) {
      case CountryType.EuropeAllyOrUs:
        for (let country of europeCountries) {
          countries.push({ value: country, label: displayStringFromCountry(country) });
        }
        for (let country of majorAllyCountries) {
          countries.push({ value: country, label: displayStringFromCountry(country) });
        }
        countries.push({ value: "US", label: displayStringFromCountry("US") });
        break;
      default:
        for (let country of boycottCountries) {
          countries.push({ value: country, label: displayStringFromCountry(country) });
        }
        break;
    }
    countries.sort((a, b) => a.label.localeCompare(b.label))
    setCountries(countries);

    const selected: Option[] = []
    const found = countries.find((c) => c.value === props.country)
    if (found) {
      selected.push(found)
    }
    setSelected(selected)
  }, [props.countryTypes, props.country])

  return (
    <StyledSelect
      options={countries}
      values={selected}
      onChange={(values) => props.onChange(values.length === 0 ? "" : values[0].value)}
      style={{
        border: '1px solid var(--border-color)',
        borderRadius: '0.25rem',
        padding: '0rem 0.5rem 0rem 0.5rem',
        minHeight: '32px'
      }}
    />
  );

}

const StyledSelect = styled(LazySelectWrapper)`
  background: var(--control-bg-color);
`;

